import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "mt-2"
};
const _hoisted_2 = {
  class: "row"
};
const _hoisted_3 = {
  class: "col-12 text-left fw-extra-bold fsi-16"
};
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "horizontal-dividing-line mb-4 mt-3"
}, null, -1);
const _hoisted_5 = {
  key: 0,
  class: "i-layer"
};
const _hoisted_6 = {
  class: "row"
};
const _hoisted_7 = {
  class: "col-12 mb-3"
};
const _hoisted_8 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_9 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_10 = {
  class: "code-style fw-medium fsi-14 position-relative d-flex justify-content-between align-items-center"
};
const _hoisted_11 = {
  style: {
    "max-width": "70%"
  }
};
const _hoisted_12 = {
  key: 1,
  class: "cursor-pointer fsi-14",
  style: {
    "color": "#d2d1d1"
  }
};
const _hoisted_13 = {
  class: "i-layer"
};
const _hoisted_14 = {
  class: "row"
};
const _hoisted_15 = {
  key: 0,
  class: "col-12 mb-3 mt-3"
};
const _hoisted_16 = {
  class: "fw-medium fsi-14 d-flex align-items-center mb-2 justify-content-between",
  style: {
    "line-height": "1.6"
  }
};
const _hoisted_17 = {
  class: "mr-1 fw-bold fsi-16"
};
const _hoisted_18 = {
  key: 0
};
const _hoisted_19 = {
  key: 1
};
const _hoisted_20 = {
  class: "d-flex align-items-center"
};
const _hoisted_21 = {
  key: 1,
  class: "col-12 mt-2"
};
const _hoisted_22 = {
  key: 2,
  class: "w-100 i-layer mb-2"
};
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1);
const _hoisted_24 = {
  key: 3,
  class: "col-12 mt-2"
};
const _hoisted_25 = {
  key: 1,
  class: "mt-2 OffBoardingStep1"
};
const _hoisted_26 = {
  class: "row"
};
const _hoisted_27 = {
  class: "col-12"
};
const _hoisted_28 = {
  class: "i-layer mb-2"
};
const _hoisted_29 = {
  class: "row mb-3 mt-3"
};
const _hoisted_30 = {
  class: "col-12 mb-1"
};
const _hoisted_31 = {
  key: 0,
  class: "row mt-4"
};
const _hoisted_32 = {
  class: "col-12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CopyDocument = _resolveComponent("CopyDocument");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_input = _resolveComponent("el-input");
  const _component_Tip = _resolveComponent("Tip");
  const _component_Singer = _resolveComponent("Singer");
  const _component_AdCard2 = _resolveComponent("AdCard2");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('common.Node')) + " f0" + _toDisplayString($props.nodeId), 1)]), _hoisted_4, _withDirectives((_openBlock(), _createElementBlock("div", null, [$data.showCurrentOperator ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('Operator.Current Operator')), 1)]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, _toDisplayString($options.currentNode.operator), 1), !$data.isCopy && $options.currentNode.operator !== '' ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "cursor-pointer copy-text fsi-18",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.copy && $options.copy(...args)),
    style: {
      "border": "1px solid #dcdcdc",
      "padding": "6px",
      "display": "inline-flex",
      "border-radius": "5px"
    }
  }, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
    _: 1
  })])) : _createCommentVNode("", true), $data.isCopy ? (_openBlock(), _createElementBlock("div", _hoisted_12, " copied ")) : _createCommentVNode("", true)])])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [$data.showNewOperator ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('Operator.New Operator')), 1), !$data.affirmOperator ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [!$options.isConnected ? (_openBlock(), _createElementBlock("div", _hoisted_18, [_createVNode(_component_el_button, {
    onClick: $options.connectWallet,
    size: "small",
    round: ""
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Operator.Current Wallet')), 1)]),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true), $options.isConnected ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(_component_el_button, {
    onClick: $options.setCurrentWallet,
    size: "small",
    round: ""
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Operator.Current Wallet')), 1)]),
    _: 1
  }, 8, ["onClick"])])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_el_input, {
    size: "large",
    disabled: $data.affirmOperator,
    style: {
      "height": "50px"
    },
    onKeyup: _withKeys($options.affirm, ["enter"]),
    modelValue: $data.newOperator,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.newOperator = $event),
    placeholder: _ctx.$t('Operator.Current Wallet Tip')
  }, null, 8, ["disabled", "onKeyup", "modelValue", "placeholder"])])])) : _createCommentVNode("", true), !$data.showNewOperator && !$data.affirmOperator ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    onClick: $options.reapprove,
    loading: $data.loading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Operator.Reapprove')), 1)]),
    _: 1
  }, 8, ["onClick", "loading"])])) : _createCommentVNode("", true), !$data.isHaveActorId ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_Tip, {
    level: "error"
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Operator.Actor Not Found')), 1), _hoisted_23, _createTextVNode(" " + _toDisplayString(_ctx.$t('Operator.You should recharge this address with some FIL')), 1)]),
    _: 1
  })])) : _createCommentVNode("", true), $data.showNewOperator && !$data.affirmOperator ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    onClick: $options.affirm,
    loading: $data.loading
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Onboarding.Confirm')), 1)]),
    _: 1
  }, 8, ["onClick", "loading"])])) : _createCommentVNode("", true)])]), $data.affirmOperator ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createVNode(_component_Singer, {
    ref: "singer",
    nodeRole: $data.nodeRole,
    singerMultiple: $data.singerMultiple,
    singerType: "approval",
    btnProposal: "Send Proposal",
    "contract-method": $data.contractMethod,
    contractParams: $data.contractParams,
    onNext: $options.approvedProposal2,
    originalSingerTables: $data.singerTables
  }, null, 8, ["nodeRole", "singerMultiple", "contract-method", "contractParams", "onNext", "originalSingerTables"])])]), $data.approvedProposalRes ? (_openBlock(), _createElementBlock("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createVNode(_component_AdCard2, {
    title: _ctx.$t('Operator.You have successfully approved the operator'),
    content: _ctx.$t('Operator.If the operator is changed lost'),
    "btn-text": _ctx.$t('Onboarding.View Node'),
    onBtnClick: $options.viewNode
  }, null, 8, ["title", "content", "btn-text", "onBtnClick"])])])) : _createCommentVNode("", true)])])])])) : _createCommentVNode("", true)])), [[_directive_loading, $options.currentNode.operator === '']])]);
}